import { Component } from '@angular/core';
import { AuthService } from '../../services/Auth/auth.service'
import { Router, ActivatedRoute } from '@angular/router';

import * as $ from "jquery";
declare var jQuery: any;
declare var $: any;

@Component({
  selector: '[app-header]',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeader {

  username: string;

  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit() {
    this.setUser();

    $('.dropdown-menu').on("click.bs.dropdown", function (e) {
      e.stopPropagation();
      e.preventDefault();
    });

    $('.dropdown').on('shown.bs.dropdown', function(){
      $(".account-bg").toggle();
      $('.dropdown-toggle').find('img').toggle();
      $("body").css("overflow-y", "hidden");
    });

    $('.dropdown').on("hide.bs.dropdown",function(e){
      $(".account-bg").toggle();
      $('.dropdown-toggle').find('img').toggle();
      $("body").css("overflow-y", "scroll");
    })

    if ($(".account-bg").is(':visible')) {
      $("body").css("overflow-y", "hidden");
    }
    else {
      $("body").css("overflow-y", "scroll");
    }
  }

  logout() {
    this.authService.logout();
    //this.router.navigate(['/auth/login']);
  }

  setUser() {
    const user = this.authService.getCurrentUser();

    if (user) {

      if (user.name) {
        this.username = user.name;
      }
      else
        this.username = user.email;
    }
  }

  checkAccount() {
    $('.dropdown').dropdown('toggle')
    if ($(".account-bg").is(':visible')) {
      $('.dropdown-toggle').find('img').toggle();
      $(".account-bg").hide();
      $("body").css("overflow-y", "scroll");
    }
  }
}
